import { Theme, withStyles } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';

export const DialogActions = withStyles((theme: Theme) => ({
  root: {
    padding: `0 ${theme.spacing(4.5)}px ${theme.spacing(6)}px`,
  },
}))(MuiDialogActions);
